import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';
import getAppAuthByID from 'API/AppAuth/getAppAuthById';
import Warning from './Warning';

const ServiceWarningBanner = ({
    appAuth,
    companyServices,
    context = 'Management',
}) => {
    const [isDismissed, setIsDismissed] = useState(false);
    // TODO: Optimize data fetching to avoid multiple calls. Backend task. This solution is temporary
    const appAuthIds = useMemo(() => {
        const appAuthArray = Array.isArray(appAuth) ? appAuth : [appAuth];
        return appAuthArray.filter((item) => item?.id).map((item) => item.id);
    }, [appAuth]);

    const appAuthQueries = useQueries({
        queries: appAuthIds.map((id) => ({
            queryKey: ['appAuth', id],
            queryFn: async () => {
                const response = await getAppAuthByID(id);
                return response?.data;
            },
            enabled: !!id,
            staleTime: 30000,
        })),
    });

    const isLoadingAppAuth = appAuthQueries.some((query) => query.isLoading);

    const appAuthArray = useMemo(() => {
        if (isLoadingAppAuth) return [];
        return appAuthQueries
            .filter((query) => query.data)
            .map((query) => query.data);
    }, [appAuthQueries, isLoadingAppAuth]);

    const { shouldShowWarning, warningData } = useMemo(() => {
        const companyServicesArray = Array.isArray(companyServices)
            ? companyServices
            : [companyServices];

        const hasAppAuthWarning = appAuthArray.some(
            (item) =>
                item?.statusDisplay?.statusDisplayLevel !== 0 &&
                item?.statusDisplay?.statusDisplayLevel !== undefined &&
                item?.userSync === true,
        );

        const hasCompanyServicesWarning = companyServicesArray.some(
            (item) =>
                item?.statusDisplay?.statusDisplayLevel !== 0 &&
                item?.statusDisplay?.statusDisplayLevel !== undefined &&
                item?.userSyncPolicy !== 0,
        );

        const shouldShow = hasAppAuthWarning || hasCompanyServicesWarning;

        const data = {
            name: 'Warning',
            message: (
                <>
                    One or more of your integrated Platforms and/or Services
                    requires attention. {context} may be impacted until this is
                    resolved. Please check{' '}
                    <Link
                        to="/dashboard-services"
                        style={{
                            textDecoration: 'underline',
                            fontWeight: 'bold',
                        }}>
                        Service Dashboard
                    </Link>{' '}
                    for more information
                </>
            ),
        };

        return {
            shouldShowWarning: shouldShow,
            warningData: data,
        };
    }, [appAuthArray, companyServices, context]);

    const handleDismiss = () => {
        setIsDismissed(true);
    };

    if (!shouldShowWarning || isDismissed) return null;

    return (
        <Warning
            warning={warningData}
            style={{ marginBottom: '16px' }}
            onDismiss={handleDismiss}
        />
    );
};

export default ServiceWarningBanner;
